var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LMap',{attrs:{"zoom":_vm.zoom,"center":_vm.center,"max-bounds":_vm.maxBounds,"max-bounds-viscosity":_vm.maxBoundsViscosity,"options":_vm.mapOptions},on:{"update:center":function($event){return _vm.$emit('update:center', $event)},"update:zoom":function($event){return _vm.$emit('update:zoom', $event)}}},[_vm._t("tile"),_vm._t("marker")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }